// extracted by mini-css-extract-plugin
export default {"sidebarIcon":"_2WyoUPtv svg svg-small","titleIcon":"P5JiOUuw svg svg-small","titleBtn":"_3y1Pk9TS","buttonGroup":"_6-ZQQGQB"};